module.exports = __webpack_public_path__ + "img/2012-4.2f1e20a1.jpg";